import { LocationType } from '../../types';
import { makeStyles } from '@material-ui/styles';
import cn from 'clsx';

import { CupLine, VideoCamera, Text } from '@bizzabo/design-system';

interface LocationBadgeProps {
    locationType: LocationType;
}

const LocationBadge: React.FC<LocationBadgeProps> = ({ locationType }) => {
    const classes = useStyles();

    return (
        <Text variant="t81" className={classes.LocationBadge}>
            {locationType === LocationType.Physical ? (
                <CupLine className={cn(classes.locationTypeIcon, classes.cupIcon)} />
            ) : (
                <VideoCamera className={classes.locationTypeIcon} />
            )}
            {locationType === LocationType.Physical ? 'In-person' : 'Virtually'}
        </Text>
    );
};

const useStyles = makeStyles(
    theme => ({
        LocationBadge: {
            lineHeight: 1,
            display: 'flex',
            alignItems: 'center',
        },
        timeIcon: {
            display: 'flex',
            alignItems: 'center',
            marginRight: 4,
            fontSize: 17,
        },
        locationTypeIcon: {
            fontSize: 17,
            marginRight: 6,
            '& *': {
                fill: theme.customization.background.G10,
            },
        },
        cupIcon: {
            marginTop: 2,
        },
    }),
    { classNamePrefix: 'meetings-localtion-badge' }
);

export default LocationBadge;
